import { useEffect, useState } from 'react';
import { CommaFormatted, CommaFormattedFloatPost } from '../../../utils/global';
import {
  RateBracketAccordingContainer,
  RateBracketAccordingValue,
  RateBracketHeaders,
  RateBracketValue,
} from './commissionStyled';
import Heading from '../../../components/typography';
import { FieldArray } from 'formik';
import { COLORS } from '../../../constants/style/color';
import InputText from '../../../components/input-text/inputText';
import Button from '../../../components/button';
import InitialValuesForm from '../../../constants/initialValues';

interface RateBracketType {
  handleChange: any;
  errors: any;
  touched: any;
  values: any;
  setFieldValue: any;
  modalStatus: string;
  setValues?: any;
  setTouched?: any;
  setFieldTouched?: any;
  id?: string;
}

const RateBracketComponent = ({
  handleChange,
  errors,
  touched,
  values,
  setFieldValue,
  modalStatus,
  setValues,
  setTouched,
  setFieldTouched,
  id,
}: RateBracketType): JSX.Element => {
  const [hide, setHide] = useState<boolean>(false);
  const [deleted, setDeleted] = useState<boolean>(false);

  const sortFunction = (formIndex?: number) => {
    const sortedData = values?.rateBrackets?.sort(
      (a: any, b: any) =>
        Number(a?.lowerShareLimit?.replaceAll(',', '')) -
        Number(b?.lowerShareLimit?.replaceAll(',', ''))
    );
    const lowerShareLimit = values?.rateBrackets?.map((item: any) =>
      item?.lowerShareLimit?.replaceAll(',', '')
    );
    const checkDuplicate = lowerShareLimit?.some((element: any, index: number) => {
      return lowerShareLimit?.indexOf(element?.replaceAll(',', '')) !== index;
    });

    setValues({
      ...values,
      baseRate: values?.baseRate?.replaceAll(',', ''),
      rateBrackets: sortedData.map((a: any, i: number) => ({
        ...a,
        lowerShareLimit: CommaFormatted(sortedData[i]?.lowerShareLimit?.replaceAll(',', '')),
        upperBracketLimit:
          sortedData[i + 1]?.lowerShareLimit !== undefined
            ? CommaFormatted(sortedData[i + 1]?.lowerShareLimit?.replaceAll(',', ''))
            : '',
        // upperLimit:
        //   Number(a?.rate) *
        //     (Number(sortedData[i + 1]?.lowerShareLimit) - Number(a?.lowerShareLimit)) +
        //   Number(values?.baseRate),

        upperLimit:
          i === 0 && sortedData[i + 1]?.lowerShareLimit !== undefined
            ? CommaFormatted(
              Number(a?.rate?.replaceAll(',', '')) *
              (Number(sortedData[i + 1]?.lowerShareLimit?.replaceAll(',', '')) -
                Number(a?.lowerShareLimit?.replaceAll(',', ''))) +
              Number(values?.baseRate?.toString()?.replaceAll(',', ''))
            )
            : sortedData[i + 1]?.lowerShareLimit !== undefined && i !== 0
              ? CommaFormatted(
                Number(a?.rate?.replaceAll(',', '')) *
                (Number(sortedData[i + 1]?.lowerShareLimit?.replaceAll(',', '')) -
                  Number(a?.lowerShareLimit?.replaceAll(',', ''))) +
                Number(sortedData[i - 1]?.upperLimit?.replaceAll(',', ''))
              )
              : '',
      })),
    });
    setDeleted(false);
  };

  useEffect(() => {
    if (deleted) {
      sortFunction();
    }
  }, [deleted]);
  useEffect(() => {
    if (values?.rateBrackets?.some((bracket: any) => bracket.upperLimit !== '')) {
      setValues({
        ...values,
        rateBrackets: values?.rateBrackets?.map((a: any, i: number) => ({
          ...a,
          lowerShareLimit:
            a?.lowerShareLimit === ''
              ? ''
              : CommaFormatted(values?.rateBrackets[i]?.lowerShareLimit?.replaceAll(',', '')),
          upperBracketLimit:
            values?.rateBrackets[i + 1]?.lowerShareLimit !== undefined
              ? CommaFormatted(values?.rateBrackets[i + 1]?.lowerShareLimit?.replaceAll(',', ''))
              : '',
          upperLimit:
            i === 0 && values?.rateBrackets[i + 1]?.lowerShareLimit !== undefined
              ? CommaFormatted(
                Number(a?.rate?.replaceAll(',', '')) *
                (Number(values?.rateBrackets[i + 1]?.lowerShareLimit?.replaceAll(',', '')) -
                  Number(a?.lowerShareLimit?.replaceAll(',', '') || 0)) +
                Number(values?.baseRate?.toString()?.replaceAll(',', ''))
              )
              : values?.rateBrackets[i + 1]?.lowerShareLimit !== undefined && i !== 0
                ? CommaFormatted(
                  Number(a?.rate?.replaceAll(',', '')) *
                  (Number(values?.rateBrackets[i + 1]?.lowerShareLimit?.replaceAll(',', '')) -
                    Number(a?.lowerShareLimit?.replaceAll(',', '') || 0)) +
                  Number(values?.rateBrackets[i - 1]?.upperLimit?.replaceAll(',', ''))
                )
                : '',
        })),
      });
    }
  }, [
    values?.rateBrackets?.map((bracket: any) => bracket.upperLimit).join(','),
    deleted,
    values?.baseRate,
  ]);
  // useEffect(() => {
  //   if (values?.rateBrackets?.some((bracket: any) => bracket.upperLimit !== '')) {
  //     setValues({
  //       ...values,
  //       rateBrackets: values?.rateBrackets?.map((a: any, i: number) => ({
  //         ...a,
  //         lowerShareLimit: CommaFormatted(
  //           values?.rateBrackets[i]?.lowerShareLimit?.replaceAll(',', '')
  //         ),
  //         upperBracketLimit:
  //           values?.rateBrackets[i + 1]?.lowerShareLimit !== undefined
  //             ? CommaFormatted(values?.rateBrackets[i + 1]?.lowerShareLimit?.replaceAll(',', ''))
  //             : '',
  //         upperLimit:
  //           i === 0 && values?.rateBrackets[i + 1]?.lowerShareLimit !== undefined
  //             ? CommaFormatted(
  //                 Number(a?.rate?.replaceAll(',', '')) *
  //                   (Number(values?.rateBrackets[i + 1]?.lowerShareLimit?.replaceAll(',', '')) -
  //                     Number(a?.lowerShareLimit?.replaceAll(',', ''))) +
  //                   Number(values?.baseRate?.toString()?.replaceAll(',', ''))
  //               )
  //             : values?.rateBrackets[i + 1]?.lowerShareLimit !== undefined && i !== 0
  //             ? CommaFormatted(
  //                 Number(a?.rate?.replaceAll(',', '')) *
  //                   (Number(values?.rateBrackets[i + 1]?.lowerShareLimit?.replaceAll(',', '')) -
  //                     Number(a?.lowerShareLimit?.replaceAll(',', ''))) +
  //                   Number(values?.rateBrackets[i - 1]?.upperLimit?.replaceAll(',', ''))
  //               )
  //             : '',
  //       })),
  //     });
  //     // sortFunction();
  //   }
  // }, [values?.rateBrackets?.map((bracket: any) => bracket.upperLimit).join(','), deleted]);
  // useEffect(() => {
  //   if (values?.rateBrackets?.some((bracket: any) => bracket.upperLimit !== '' )) {
  //     setValues({
  //       ...values,
  //       rateBrackets: values?.rateBrackets?.map((a: any, i: number) => ({
  //         ...a,
  //         lowerShareLimit: CommaFormatted(
  //           values?.rateBrackets[i]?.lowerShareLimit?.replaceAll(',', '')
  //         ),
  //         upperBracketLimit:
  //           values?.rateBrackets[i + 1]?.lowerShareLimit !== undefined
  //             ? CommaFormatted(values?.rateBrackets[i + 1]?.lowerShareLimit?.replaceAll(',', ''))
  //             : '',
  //         upperLimit:
  //           i === 0 && values?.rateBrackets[i + 1]?.lowerShareLimit !== undefined
  //             ? CommaFormatted(
  //                 Number(a?.rate?.replaceAll(',', '')) *
  //                   (Number(values?.rateBrackets[i + 1]?.lowerShareLimit?.replaceAll(',', '')) -
  //                     Number(a?.lowerShareLimit?.replaceAll(',', ''))) +
  //                   Number(values?.baseRate?.replaceAll(',', ''))
  //               )
  //             : values?.rateBrackets[i + 1]?.lowerShareLimit !== undefined && i !== 0
  //             ? CommaFormatted(
  //                 Number(a?.rate?.replaceAll(',', '')) *
  //                   (Number(values?.rateBrackets[i + 1]?.lowerShareLimit?.replaceAll(',', '')) -
  //                     Number(a?.lowerShareLimit?.replaceAll(',', ''))) +
  //                   Number(values?.rateBrackets[i - 1]?.upperLimit?.replaceAll(',', ''))
  //               )
  //             : '',
  //       })),
  //     });
  //     // sortFunction();
  //   }
  // }, [values?.rateBrackets?.map((bracket: any) => bracket.upperLimit).join(','), deleted]);
  return (
    <div id="rateBracketComponentContainer">
      <RateBracketAccordingContainer className='flex justify-between mt-5 mb-5' id="rateBracketHeaderContainer">
        <Heading variant='body' title={'Rate Bracket'} id="rateBracketTitle" />
        <div
          className='flex'
          onClick={() => {
            setHide(!hide);
          }}
          id="rateBracketToggleContainer">
          {!hide ? (
            <>
              <span className='material-symbols-outlined image-icon cursor-pointer' id="rateBracketExpandLess">
                expand_less
              </span>
            </>
          ) : (
            <>
              <span className='material-symbols-outlined image-icon cursor-pointer' id="rateBracketExpandMore">
                expand_more
              </span>
            </>
          )}
        </div>
      </RateBracketAccordingContainer>
      <FieldArray
        name='rateBrackets'
        render={(arrayHelpers) => {
          return (
            <div id="rateBracketFieldArrayContainer">
              {!hide && (
                // <motion.div
                //   initial={{ y: -2, opacity: 0 }}
                //   animate={{ y: 0, opacity: 1 }}
                //   transition={{
                //     delay: 0.5,
                //     duration: 0.3,
                //   }}>
                <>
                  <RateBracketAccordingValue id="rateBracketAccordingValue">
                    {/* <motion.div initial={{ y: 10 }} animate={{ y: 0 }}> */}

                    <RateBracketHeaders className='grid grid-cols-12 gap-x-5' id="rateBracketHeaders">
                      <div className='col-span-2' id="rateHeader">
                        <Heading variant='body-xs' title={'Rate $/share'} color={COLORS.Gray} id="rateHeaderTitle" />
                      </div>
                      <div className='col-span-3' id="lowerBracketHeader">
                        <Heading
                          variant='body-xs'
                          title={'Lower Bracket Limit (Shr)'}
                          color={COLORS.Gray}
                          id="lowerBracketHeaderTitle"
                        />
                      </div>
                      <div className='col-span-3' id="upperBracketHeader">
                        <Heading
                          variant='body-xs'
                          title={'Upper Bracket Limit (Shr)'}
                          color={COLORS.Gray}
                          id="upperBracketHeaderTitle"
                        />
                      </div>
                      <div className='col-span-3' id="upperLimitHeader">
                        <Heading variant='body-xs' title={'$ At Upper Limit'} color={COLORS.Gray} id="upperLimitHeaderTitle" />
                      </div>
                    </RateBracketHeaders>

                    <div id="rateBracketRowsContainer">
                      {values?.rateBrackets &&
                        values.rateBrackets.length > 0 &&
                        values.rateBrackets.map(
                          (taxBracket: Record<string, number | string>, index: number) => {
                            return (
                              <RateBracketValue
                                className='grid lg:grid-cols-12 sm:grid-cols-1 items-start gap-x-5'
                                key={index}
                                id={`rateBracketRow.${index}`}>
                                <div className='col-span-2' id={`rateContainer.${index}`}>
                                  <InputText
                                    type='text'
                                    name={`rateBrackets[${index}].rate`}
                                    id={`rateBrackets.${index}.rate`}
                                    onChange={handleChange}
                                    onFocus={(e: any) => {
                                      values?.rateBrackets?.[index]?.rate.replaceAll(',', '');
                                    }}
                                    onBlur={(e: any) => {
                                      CommaFormattedFloatPost(
                                        e.target.value,
                                        `rateBrackets.${index}.rate`,
                                        setFieldValue
                                      );
                                      setFieldTouched(`rateBrackets.${index}.rate`, true);
                                    }}
                                    errorValue={errors?.rateBrackets?.[index]?.rate}
                                    touchedValue={touched?.rateBrackets?.[index]?.rate}
                                    errors={errors}
                                    touched={touched}
                                    disabled={modalStatus === 'View'}
                                    required
                                  />
                                </div>
                                <div className='col-span-3' id={`lowerShareLimitContainer.${index}`}>
                                  <InputText
                                    type='text'
                                    name={`rateBrackets[${index}].lowerShareLimit`}
                                    id={`rateBrackets.${index}.lowerShareLimit`}
                                    errorValue={errors?.rateBrackets?.[index]?.lowerShareLimit}
                                    touchedValue={touched?.rateBrackets?.[index]?.lowerShareLimit}
                                    onChange={(e: any) => {
                                      handleChange(e);
                                      CommaFormatted(
                                        e.target.value,
                                        `rateBrackets[${index}].lowerShareLimit`,
                                        setFieldValue
                                      );
                                    }}
                                    onFocus={(e: any) => {
                                      setFieldValue(
                                        `rateBrackets[${index}].lowerShareLimit`,
                                        e.target.value.replaceAll(',', '')
                                      );
                                    }}
                                    onBlur={(e: any) => {
                                      sortFunction(index);
                                    }}
                                    errors={errors}
                                    touched={touched}
                                    disabled={modalStatus === 'View'}
                                    required
                                  />
                                </div>
                                <div className='col-span-3' id={`upperBracketLimitContainer.${index}`}>
                                  <InputText
                                    type='text'
                                    name={`rateBrackets[${index}].upperBracketLimit`}
                                    id={`rateBrackets.${index}.upperBracketLimit`}
                                    errorValue={errors?.rateBrackets?.[index]?.upperBracketLimit}
                                    touchedValue={touched?.rateBrackets?.[index]?.upperBracketLimit}
                                    onChange={(e: any) => {
                                      handleChange(e);
                                      CommaFormatted(
                                        e.target.value,
                                        `rateBrackets[${index}].upperBracketLimit`,
                                        setFieldValue
                                      );
                                    }}
                                    errors={errors}
                                    touched={touched}
                                    disabled={true}
                                    required
                                  />
                                </div>
                                <div className='col-span-3' id={`upperLimitContainer.${index}`}>
                                  <InputText
                                    type='text'
                                    name={`rateBrackets[${index}].upperLimit`}
                                    id={`rateBrackets.${index}.upperLimit`}
                                    errorValue={errors?.rateBrackets?.[index]?.upperLimit}
                                    touchedValue={touched?.rateBrackets?.[index]?.upperLimit}
                                    onChange={(e: any) => {
                                      handleChange(e);
                                      CommaFormatted(
                                        e.target.value,
                                        `rateBrackets[${index}].upperLimit`,
                                        setFieldValue
                                      );
                                    }}
                                    errors={errors}
                                    touched={touched}
                                    disabled={true}
                                    required
                                  />
                                </div>
                                {modalStatus !== 'View' && values.rateBrackets.length > 1 && (
                                  <div id={`deleteRateBracketContainer.${index}`}>
                                    <span
                                      className='material-symbols-outlined text-red-600 mt-3 cursor-pointer'
                                      id={`deleteRateBracketButton.${index}`}
                                      onClick={() => {
                                        arrayHelpers.remove(index);
                                        setDeleted(true);
                                      }}>
                                      delete
                                    </span>
                                  </div>
                                )}
                              </RateBracketValue>
                            );
                          }
                        )}

                      {modalStatus !== 'View' && (
                        <div id="addRateBracketButtonContainer">
                          <Button
                            title='Add Rate Bracket'
                            type='button'
                            variant='primary-dark'
                            icon='group_add'
                            btnClassName='w-full'
                            id="addRateBracketButton"
                            onClick={() => {
                              arrayHelpers.push({
                                ...InitialValuesForm.commission.rateBrackets[0],
                                lowerShareLimit: '',
                              });
                              setTouched({
                                ...touched,
                                rateBrackets: [
                                  ...touched?.rateBrackets,
                                  {
                                    rate: true,
                                    lowerShareLimit: true,
                                    upperLimit: true,
                                  },
                                ],
                              });
                            }}
                          />
                        </div>
                      )}
                    </div>
                    {/* </motion.div> */}
                  </RateBracketAccordingValue>
                  {/* </motion.div> */}
                </>
              )}
            </div>
          );
        }}
      />
    </div>
  );
};

export default RateBracketComponent;
